module.exports = __webpack_public_path__ + "static/img/logoAbcPa.c7d0705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoAbcPa.png
// module id = wVBe
// module chunks = 5